import { Plus } from "lucide-react";
import { SearchNormal } from "iconsax-reactjs";
import { Button, Input, Select } from "../../../../shared/ui";

type RolesPermissionsHeaderProps = {
  query: string;
  sort: string;
  onQueryChange: (value: string) => void;
  onSortChange: (value: string) => void;
  onCreateRole: () => void;
};

const sortOptions = [
  { label: "Recently created", value: "recent" },
  { label: "Oldest created", value: "oldest" },
  { label: "A - Z", value: "a-z" },
  { label: "Z - A", value: "z-a" },
  {
    label: "Permissions: Least - Most",
    value: "permissions-asc",
  },
  {
    label: "Permissions: Most - Least",
    value: "permissions-desc",
  },
  { label: "Members: Least - Most", value: "members-asc" },
  { label: "Members: Most - Least", value: "members-desc" },
];

const RolesPermissionsHeader = ({
  query,
  sort,
  onQueryChange,
  onSortChange,
  onCreateRole,
}: RolesPermissionsHeaderProps) => {
  return (
    <div className="mt-5 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <Button
        className="order-1 w-1/2  sm:w-fit lg:order-2"
        onClick={onCreateRole}
      >
        <Plus size={18} />
        Create new role
      </Button>

      <div className="order-2 flex flex-col gap-3 sm:flex-row sm:items-center lg:order-1">
        <Input
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Search roles"
          startIcon={<SearchNormal size={20} className="text-[#6F739B]" />}
          className="w-full sm:min-w-[300px]"
        />
        <Select
          value={sort}
          onChange={onSortChange}
          title="Sort by"
          options={sortOptions}
        />
      </div>
    </div>
  );
};

export default RolesPermissionsHeader;
